var _dec, _class, _FileSave;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@instructure/ui-buttons';
import { TextInput } from '@instructure/ui-text-input';
import { withStyle, jsx } from '@instructure/emotion';
import { View } from '@instructure/ui-view';
import StartOver from '../StartOver';
import { translate } from '../../../constants/translated/translations';
import generateStyle from './styles';

/**
---
private: true
---
**/
let FileSave = (_dec = withStyle(generateStyle, null), _dec(_class = (_FileSave = class FileSave extends Component {
  constructor(props) {
    super(props);
    this.onChange = () => {
      this.setState({
        fileName: this.input.value
      });
    };
    this.saveClicked = e => {
      this.props.onSaveClicked(this.state.fileName.trim());
    };
    this.state = {
      fileName: this.props.defaultFileName
    };
  }
  componentDidMount() {
    this.props.makeStyles();
  }
  componentDidUpdate() {
    this.props.makeStyles();
  }
  renderStartOverButton() {
    return jsx(StartOver, {
      onClick: this.props.onStartoverClicked,
      disabled: this.props.disabled
    });
  }
  renderSaveMediaButton() {
    return jsx(Button, {
      onClick: this.saveClicked,
      interaction: this.props.disabled ? 'disabled' : 'enabled',
      color: "primary",
      size: "medium",
      display: "block",
      textAlign: "center",
      id: "media_capture_save_button" // needed for impact app
    }, translate('SAVE_MEDIA'));
  }
  render() {
    const _this$props = this.props,
      styles = _this$props.styles,
      defaultFileName = _this$props.defaultFileName;
    return jsx(View, {
      as: "div",
      css: styles.fileSaveContainer
    }, jsx(View, {
      as: "div",
      css: styles.videoTitleContainer
    }, jsx(TextInput, {
      id: "media_capture_title_field" // needed for impact app
      ,
      renderLabel: translate('SR_FILE_INPUT'),
      placeholder: defaultFileName,
      onChange: this.onChange,
      inputRef: e => {
        this.input = e;
      },
      interaction: this.props.disabled ? 'disabled' : 'enabled'
    })), jsx(View, {
      as: "div",
      css: styles.startOverButton
    }, this.renderStartOverButton()), jsx(View, {
      as: "div",
      css: styles.saveMediaButton
    }, this.renderSaveMediaButton()));
  }
}, _FileSave.propTypes = {
  // eslint-disable-next-line react/require-default-props
  makeStyles: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  styles: PropTypes.object,
  disabled: PropTypes.bool.isRequired,
  defaultFileName: PropTypes.string.isRequired,
  onSaveClicked: PropTypes.func.isRequired,
  onStartoverClicked: PropTypes.func.isRequired
}, _FileSave)) || _class);
export { FileSave as default };